import axios from "axios";
import authHeader from "./auth-header";
import { baseURL } from "../constants";

class SyncOneDataService {
  trigger(type, params) {
    return axios.post(
      baseURL + "/sync-onedata/trigger",
      Object.assign({ type: type }, params),
      { headers: authHeader() }
    );
  }

  status(logId) {
    return axios.get(baseURL + "/sync-onedata/status/" + logId, {
      headers: authHeader()
    });
  }

  cancel(logId) {
    return axios.post(baseURL + "/sync-onedata/cancel/" + logId, {}, {
      headers: authHeader()
    });
  }

  history(type) {
    var url = baseURL + "/sync-onedata/history";
    if (type) url += "?type=" + type;
    return axios.get(url, { headers: authHeader() });
  }

  // ===== Sync API settings (credential & endpoint) =====
  getSettings() {
    return axios.get(baseURL + "/sync-settings", { headers: authHeader() });
  }

  saveSettings(payload) {
    return axios.post(baseURL + "/sync-settings", payload, { headers: authHeader() });
  }

  testConnection(provider) {
    return axios.post(baseURL + "/sync-settings/test", { provider: provider }, { headers: authHeader() });
  }
}

export default new SyncOneDataService();
